import Vue from "vue";

export default {
    recuperarHistoricosAcaoProcesso(processoOid) {
        return Vue.axios.get("historicoAcaoProcesso/" + processoOid);
    },
};
